import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { createGrid as createGridMutation } from "@/graphql/mutations";
import { GraphQLError } from "graphql";
import type { Grid } from "@/API";
import { addGridInGrids } from "./getGridsState";

const client = generateClient();

export const createGridState = create<State<Grid | null>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const createGridIsloading = () =>
  createGridState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const createGridIsError = (error: GraphQLError[] | undefined) =>
  createGridState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const createGridIsSuccess = (queryResult: Grid) =>
  createGridState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetCreateGridState = () =>
  createGridState.setState(() => createGridState.getInitialState());

type CreateGridParams = {
  restaurantIds: string[];
  name: string;
  columns: string[];
};

export const createGrid = async (params: CreateGridParams) => {
  createGridIsloading();
  const { restaurantIds, name, columns } = params;

  try {
    const { data } = await client.graphql({
      query: createGridMutation,
      variables: {
        restaurantIds,
        name,
        columns,
      },
    });

    createGridIsSuccess(data.createGrid);
    addGridInGrids(data.createGrid);
  } catch (e) {
    const graphQl = e as GraphQLResult<Grid>;
    createGridIsError(graphQl.errors);
  }
};
